import { FC } from 'react'

import { ClipboardItem } from '@/components'
import { SellTreez } from '@/models/sellTreez'

interface Props {
  sellTreez?: SellTreez
}

const SellTreezInfraTabContent: FC<Props> = ({ sellTreez }) => {
  const parsedOutput = sellTreez?.outputs && JSON.parse(sellTreez?.outputs)
  const readerLambda = parsedOutput?.Lambdas?.Reader?.name
  const writerLambda = parsedOutput?.Lambdas?.Writer?.name
  const openSearch = parsedOutput?.OpenSearch
  const eventBus = parsedOutput?.EventBus
  const sellTreezQueue = parsedOutput?.SellTreezQueue
  const dynamoDB = parsedOutput?.DynamoDB
  const apiGateway = parsedOutput?.ApiGateway

  const sections = [
    {
      title: 'Lambdas',
      items: [
        { label: 'Reader', value: readerLambda },
        { label: 'Writer', value: writerLambda },
      ],
    },
    {
      title: 'OpenSearch',
      items: Object.entries(openSearch ?? {}).map(([key, value]) => ({ label: key, value })),
    },
    {
      title: 'EventBus',
      items: Object.entries(eventBus ?? {})
        .slice(0, -1)
        .map(([key, value]) => ({ label: key, value })),
    },
    {
      title: 'SellTreezQueue',
      items: Object.entries(sellTreezQueue ?? {})
        .slice(0, -1)
        .map(([key, value]) => ({ label: key, value })),
    },
    {
      title: 'DynamoDB',
      items: Object.entries(dynamoDB ?? {}).map(([key, value]) => ({ label: key, value })),
    },
    {
      title: 'ApiGateway',
      items: Object.entries(apiGateway ?? {})
        .slice(0, -1)
        .map(([key, value]) => ({ label: key, value })),
    },
  ]

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 gap-2 gap-y-12 divide-gray-100">
        {sections.map(({ title, items }) => (
          <div
            className="flex-1 flex flex-col gap-4 even:pl-6 odd:pr-6 even:border-l-2 border-gray-100"
            key={title}
          >
            <label className="py-2">{title}</label>
            {items.map(({ label, value }, index) => (
              <ClipboardItem key={index} headless value={value}>
                {({ onClick, clipboardIcon }) => (
                  <div className="grid grid-cols-[132px_1fr_auto] gap-6">
                    <div className="text-gray-400 break-all">{label}:</div>
                    <span className="text-gray-700 break-all">{value}</span>
                    <div className="flex justify-end" onClick={onClick} role="button">
                      <span className="self-start">{clipboardIcon}</span>
                    </div>
                  </div>
                )}
              </ClipboardItem>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export { SellTreezInfraTabContent }
